import React, {useEffect, useState} from 'react';
import {Controller} from "react-hook-form";
import debounce from 'lodash/debounce'
import {flowServices} from "../../service/flowService";
import {alertActions} from "../../store/actions/alertActions";
import {connect} from "react-redux";
import {Autocomplete, TextField} from "@mui/material";
import {flowSelectPaperStyles} from "./FlowDesign";

function FlowSelect(props) {

    const {control, inputName, countryCode, errorMsg} = props;

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [requestError, setRequestError] = useState('');

    useEffect(() => {
        async function fetchData(search, countryCode): void {
            setLoading(true);
            setRequestError('');
            await flowServices.read(search, countryCode).then((response) => {
                setOptions(
                    response?.flows?.map(item => {
                        let code = item?.countryCode
                        if (code === "") {
                            code = "Global";
                        }
                        return {
                            value: item?.id,
                            label: code + " - " + item?.name,
                            flow: item?.flow
                        }
                    })
                );
            }).catch((e) => {
                setRequestError('Unable to load shared flows. Close and reopen the list to retry.');
            }).finally(() => {
                setLoading(false);
            });
        }

        if (open && (search.length === 0 || search.length > 0)) {
            fetchData(search, countryCode);
        }

    }, [search, open, countryCode, errorMsg]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
            setSearch("");
        }
    }, [open]);

    const handleSearch = debounce(searchTerm => {
        setSearch(searchTerm);
    }, 800);

    return (
        <Controller
            render={({field: {onChange, ...props}, fieldState}) => (
                <Autocomplete
                    open={open}
                    onOpen={() => {
                        setOpen(true);
                    }}
                    onClose={() => {
                        setOpen(false);
                    }}
                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                    getOptionLabel={(option) => option?.label ? option.label : ""}
                    options={options}
                    loading={loading}
                    fullWidth
                    slotProps={{paper: {sx: flowSelectPaperStyles}}}
                    renderInput={params => (
                        <TextField
                            {...params}
                            error={!!fieldState.error || !!requestError}
                            helperText={fieldState.error?.message || requestError || undefined}
                            label="Shared flow *"
                            placeholder="Select a flow"
                            variant="outlined"
                            margin="dense"
                            size="small"
                            value={search}
                            onChange={e => handleSearch(e.target.value)}
                            slotProps={{
                                inputLabel: {
                                    shrink: true
                                },
                                input: {
                                    ...params.InputProps,
                                }
                            }}
                        />
                    )}
                    onChange={(e, data) => {
                        setRequestError('');
                        onChange(data);
                    }}
                    {...props}
                />
            )}
            rules={{required: 'Please select a shared flow.', validate: value => value?.value > 0 || 'Please select a shared flow.'}}
            name={inputName}
            control={control}
            defaultValue={null}
        />
    );
}

const mapDispatchToProps = {
    errorMsg: alertActions.error
};

export default connect(null, mapDispatchToProps)(FlowSelect);
